import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { isEmpty } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
let DeviceIdData = class DeviceIdData extends VuexModule {
    taskType = '';
    deviceIdRequestParams = new Map();
    unwantedRoi = ['FACE_ATTRIBUTE', 'FACE_PEDESTRIAN_ALERT', 'FACE_ALERT'];
    localPlotData = []; // 绘制的roi
    currentRtspUrl = ''; // 当前设备的rtsp
    deviceId = '';
    selectedDeviceIdList = [];
    monitoringIndex = 1; // 监听指标
    complete = false; // 选中的设备时候都绘制完成
    roiList = [];
    polygonsMapData = [];
    isMap = false;
    isMapData = false;
    markMapData = new Map();
    isHave = false;
    currentDeviceDetails = {}; // 当前设备详情
    get deviceFromData() {
        // 不需要画roi的
        const noNeedRoi = this.unwantedRoi.includes(this.taskType);
        const data = [];
        if (noNeedRoi && !isEmpty(this.deviceIdRequestParams) && this.taskType) {
            this.deviceIdRequestParams.forEach((item) => {
                const type = plotMap.get(this.taskType).incidentType;
                data.push({ ...item, incidentType: type });
            });
        }
        else {
            // 需要画roi 和 人体
            // 需要画roi 反向 人体
            // 需要画roi 地图 人体
            if (!isEmpty(this.deviceIdRequestParams)) {
                this.deviceIdRequestParams.forEach((item) => {
                    const type = plotMap.get(this.taskType).incidentType;
                    data.push({ zoneId: item.zoneId, deviceId: item.deviceId, incidentType: type, roi: item.titleList });
                });
            }
        }
        return data;
    }
    setTaskType(value) {
        this.taskType = value;
    }
    setDeviceIdRequestParams(val) {
        this.deviceIdRequestParams = val;
    }
    updataRoi(roi) {
        this.localPlotData = roi;
    }
    updataCurrentRtspUrl(rtsp) {
        this.currentRtspUrl = rtsp;
    }
    updataDeviceId(id) {
        this.deviceId = id;
    }
    updataSelectedDeviceIdList(val) {
        this.selectedDeviceIdList = val;
    }
    updataMonitoringIndex() {
        this.monitoringIndex++;
    }
    clearMonitoringIndex() {
        this.monitoringIndex = 1;
    }
    updataComplete(val) {
        this.complete = val;
    }
    updataPaintData(roi) {
        this.roiList.push(roi);
    }
    updataPolygonsMapData(data) {
        this.polygonsMapData = data;
    }
    updataMapData(data) {
        this.isMap = data;
    }
    updataIsHave(data) {
        this.isHave = data;
    }
    updataIsMapData(data) {
        this.isMapData = data;
    }
    updateCurrentDeviceDetails(data) {
        this.currentDeviceDetails = data;
    }
};
__decorate([
    Mutation
], DeviceIdData.prototype, "setTaskType", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "setDeviceIdRequestParams", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataRoi", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataCurrentRtspUrl", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataDeviceId", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataSelectedDeviceIdList", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataMonitoringIndex", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "clearMonitoringIndex", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataComplete", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataPaintData", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataPolygonsMapData", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataMapData", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataIsHave", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updataIsMapData", null);
__decorate([
    Mutation
], DeviceIdData.prototype, "updateCurrentDeviceDetails", null);
DeviceIdData = __decorate([
    Module({ dynamic: true, store, namespaced: true, name: 'senseXplorer/DeviceIdData' })
], DeviceIdData);
export const DeviceIdDataModule = getModule(DeviceIdData);
